import type { CategoryListItem } from '@/types/apis/Category';

const recursiveFindParents = (
  category: CategoryListItem,
  categories: CategoryListItem[] | null[]
): CategoryListItem[] => {
  const parent = categories.find((item) => item?.id === category.parent_id);
  if (parent) {
    return [parent, ...recursiveFindParents(parent, categories)];
  }
  return [];
};

export default recursiveFindParents;
